import React from 'react';
import { pageCopyOptions, snippetCopyOptions } from './PageFormUtil';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { checkPageSnapPermission, checkSnippetSnapPermission } from '../../home/app_util';
import { dynamicSort } from '../../../common/utils/api_utils';

const CommonPageSetting = ({
  pages,
  page,
  pageSnapshots,
  state,
  handleChange,
  snippets,
  snippetSnapshots,
}) => {
  const isPageAllow = checkPageSnapPermission();
  const isSnippetAllow = checkSnippetSnapPermission();
  const showCloneFrom = () => {
    const { activeTab, pageClone, pageCloneWith } = state;
    if (!page.uuid) {
      return (
        <div className="form-group">
          <label style={{ paddingBottom: '0px' }}>Copy Content From:</label>
          <br />
          <input
            type="radio"
            name="pageCloneWith"
            checked={pageCloneWith === 'page_snapshot'}
            value="page_snapshot"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
          <label> &nbsp; Page/Snapshot (Optional)</label>
          <input
            style={{ marginLeft: '4rem' }}
            type="radio"
            name="pageCloneWith"
            checked={pageCloneWith === 'snippet'}
            value="snippet"
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
          <label> &nbsp; Snippet/Segment (Optional)</label>
          {pageCloneWith === 'page_snapshot' && (
            <CustomSelect
              name="pageClone"
              isMulti={false}
              onChange={handleChange}
              options={pageCopyOptions('Copy')}
              value={pageClone}
            />
          )}
          {pageCloneWith === 'snippet' && (
            <CustomSelect
              name="pageClone"
              isMulti={false}
              onChange={handleChange}
              options={snippetCopyOptions('Copy')}
              value={pageClone}
            />
          )}
        </div>
      );
    } else if (page.uuid && activeTab === '3') {
      const options = [
        ...pageCopyOptions('Replace'),
        ...snippetCopyOptions('Replace').filter((option) => option.value !== ''),
      ];
      return (
        <div className="form-group">
          <label>Replace Page With</label>
          <small>
            ( It will replace the page content with the selected Page / Snapshot content. )
          </small>
          <CustomSelect
            name={'pageClone'}
            isMulti={false}
            onChange={handleChange}
            options={options}
            value={pageClone}
          />
        </div>
      );
    }
  };
  const pageOptions = () => {
    let options = [{ value: '', label: '- Select Page -' }];
    if (pages.length > 0) {
      options = options.concat(
        pages.sort(dynamicSort('name')).map((page) => {
          return { value: page.uuid, label: page.name };
        }),
      );
    }
    return options;
  };
  const showExistingPagesOptions = () => {
    const { activeTab, pageClone, cloneFrom } = state;
    if (!page.uuid && pageClone === 'fromExistingPages') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneFrom'}
            isMulti={false}
            onChange={handleChange}
            options={pageOptions()}
            value={cloneFrom}
          />
        </div>
      );
    } else if (page.uuid && pageClone === 'fromExistingPages' && activeTab === '3') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneFrom'}
            isMulti={false}
            onChange={handleChange}
            options={pageOptions()}
            value={cloneFrom}
          />
        </div>
      );
    } else {
      return '';
    }
  };
  const pageSnapshotOptions = () => {
    let options = [{ value: '', label: '- Select Page Snapshot -' }];

    if (pageSnapshots.length > 0) {
      const sortedSnapshots = pageSnapshots.sort(dynamicSort('createdAt')).reverse();
      options = options.concat(
        sortedSnapshots.map((snapshot) => ({
          value: snapshot.uuid,
          label: snapshot.name,
        })),
      );
    }
    return options;
  };
  const showPagePermissionError = () => {
    return (
      <div class="col-12 mt-3">
        To use Page Snapshots, please upgrade your plan.{' '}
        <a
          href={`${process.env.REACT_APP_ORGANIZATION}accounts`}
          className="btn btn-sm btn-theme-submit"
        >
          <i className="wb webconnect-paper-plane-fill"></i> Upgrade
        </a>
      </div>
    );
  };

  const showPageSnapshotsOptions = () => {
    const { activeTab, pageClone, restoreFrom } = state;
    if (!page.uuid && pageClone === 'fromPageSnapshots') {
      if (!isPageAllow) {
        return showPagePermissionError();
      }
      return (
        <div className="form-group">
          <CustomSelect
            name={'restoreFrom'}
            isMulti={false}
            onChange={handleChange}
            options={pageSnapshotOptions()}
            value={restoreFrom}
          />
        </div>
      );
    } else if (page.uuid && pageClone === 'fromPageSnapshots' && activeTab === '3') {
      if (!isPageAllow) {
        return showPagePermissionError();
      }
      return (
        <div className="form-group">
          <CustomSelect
            name={'restoreFrom'}
            isMulti={false}
            onChange={handleChange}
            options={pageSnapshotOptions()}
            value={restoreFrom}
          />
        </div>
      );
    } else {
      return '';
    }
  };
  const snippetOptions = () => {
    let options = [{ value: '', label: '- Select Snippet -' }];
    if (snippets.length > 0) {
      options = options.concat(
        snippets.sort(dynamicSort('name')).map((snippet) => {
          return { value: snippet.uuid, label: snippet.name };
        }),
      );
    }
    return options;
  };

  const showExistingSnippetOptions = () => {
    const { activeTab, pageClone, cloneSnippet } = state;
    if (!page.uuid && pageClone === 'fromExistingSnippets') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneSnippet'}
            isMulti={false}
            onChange={handleChange}
            options={snippetOptions()}
            value={cloneSnippet}
          />
        </div>
      );
    } else if (page.uuid && pageClone === 'fromExistingSnippets' && activeTab === '3') {
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneSnippet'}
            isMulti={false}
            onChange={handleChange}
            options={snippetOptions()}
            value={cloneSnippet}
          />
        </div>
      );
    } else {
      return '';
    }
  };
  const showSnippetPermissionError = () => {
    return (
      <div class="col-12 mt-3">
        To use Snippet Snapshots, please upgrade your plan.{' '}
        <a
          href={`${process.env.REACT_APP_ORGANIZATION}accounts`}
          className="btn btn-sm btn-theme-submit"
        >
          <i className="wb webconnect-paper-plane-fill"></i> Upgrade
        </a>
      </div>
    );
  };
  const snippetSnapshotOptions = () => {
    let options = [{ value: '', label: '- Select Snippet -' }];
    if (snippetSnapshots.length > 0) {
      options = options.concat(
        snippetSnapshots.sort(dynamicSort('name')).map((snippetSnapshot) => {
          return { value: snippetSnapshot.uuid, label: snippetSnapshot.name };
        }),
      );
    }
    return options;
  };

  const showSnippetSnapshotsOptions = () => {
    const { activeTab, pageClone, cloneSnippetSnapshot } = state;
    if (!page.uuid && pageClone === 'fromSnippetSnapshots') {
      if (!isSnippetAllow) {
        return showSnippetPermissionError();
      }
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneSnippetSnapshot'}
            isMulti={false}
            onChange={handleChange}
            options={snippetSnapshotOptions()}
            value={cloneSnippetSnapshot}
          />
        </div>
      );
    } else if (page.uuid && pageClone === 'fromSnippetSnapshots' && activeTab === '3') {
      if (!isSnippetAllow) {
        return showSnippetPermissionError();
      }
      return (
        <div className="form-group">
          <CustomSelect
            name={'cloneSnippetSnapshot'}
            isMulti={false}
            onChange={handleChange}
            options={snippetSnapshotOptions()}
            value={cloneSnippetSnapshot}
          />
        </div>
      );
    } else {
      return '';
    }
  };
  return (
    <>
      {showCloneFrom()}
      {showExistingPagesOptions()}
      {showPageSnapshotsOptions()}
      {showExistingSnippetOptions()}
      {showSnippetSnapshotsOptions()}
    </>
  );
};

export default CommonPageSetting;
